/* ============================================================
   pbk-wishlist-fav.js — 独自ハートボタン [data-pbk-fav] を
   smartwishlist アプリの公開 API に配線する。

   対象ボタン(装飾のみでクリック未実装だったもの):
   - ルース一覧グリッド .pbk-lcard__fav (pbk-loose-facets.js 生成)
   - ルースPDP .pbk-pdp-fav (sections/pbk-product-loose.liquid)
   - PDP関連カード .pbk-pcard__fav (snippets/pbk-loose-card.liquid / pbk-product-loose.js 生成)
   - 通常商品カード .pbk-card__fav (snippets/pbk-product-card.liquid — トップNew Arrival/検索結果)
     ※ これは <a class="pbk-card"> 内の role=button span。親アンカー遷移を抑止する。

   アプリ公開 API(smartwishlist.js が window に定義):
   - AddToSmartWishlist(product_id, variant_id)
   - RemoveFromSmartWishlist(product_id, variant_id)
   - ReloadSmartWishlist()  ← Add/Remove と初期データロード後にアプリが呼ぶ
   - getCookieSW(name)      ← アプリと同じ cookie 読取

   登録済みハートの初期塗り(is-active):
   - 未ログイン: cookie 'bookmarkeditems'({items:[[pid,vid,qty],...]}) を読む
   - ログイン時: アプリは cookie を使わず window.saved_wishlist_items(グローバル配列・
     要素は [pid,vid,qty]) にサーバのデータを入れる → そちらを優先して読む
   - どちらもアプリの非同期ロード完了後に入るため、DOMContentLoaded だけでは早すぎる
     → 短時間ポーリング + ReloadSmartWishlist ラップ + pbk:cards-rendered で複数回 sync する。

   付随して持つ、アプリ出力をテーマ表記に寄せる処理:
   - 登録/解除の直後に 'pbk:header-reveal' を発火（隠れたヘッダーを出して件数バッジを見せる）
   - お気に入りページのカードを詳細ページ「最近閲覧した商品」(.pbk-pcard)と同意匠にする:
     app の削除ボタン(a.singleremovebutton)を .image 直下へ移し、通常一覧と同じ
     ハート SVG（登録済み塗り）へ差し替える。要素そのものは作り直さず移設のみなので
     app の委譲ハンドラ($("body").on("click",".singleremovebutton")=削除確認モーダル)は
     そのまま効く。見た目は pbk-wishlist.css の .pbk-wl-card__fav 側で当てる
     （カードは 商品名 + スペック/価格の .pbk-wl-row。app 自前の価格 <p> は桁区切りが
      入らない[CL #244 実測「¥15000」]ため CSS で非表示にし、こちらの money() に一本化）
   - getproductdetails.php 障害時の共有ビュー経由フォールバック描画
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '[data-pbk-fav]';

  /* ログイン会員の登録データ。アプリ(smartwishlist.js)は customer_id != 0 のとき
     cookie 'bookmarkeditems' を使わず、サーバから取った window.saved_wishlist_items
     （要素 = [product_id, variant_id, 1] の3要素配列。アプリ自身が
     objectExists(saved_wishlist_items, [product_id, variant_id, 1]) で判定に使う）を持つ。
     cookie しか見ていなかったため、ログイン時は「登録済みなのにハートが未登録表示・
     件数バッジ 0」になっていた。 */
  function getAccountItems() {
    var items = window.saved_wishlist_items;
    if (!Array.isArray(items) || !items.length) return null;
    return items.map(function (it) {
      // 3要素配列が既定。将来オブジェクト形式に変わっても拾えるようにしておく
      if (Array.isArray(it)) return it;
      if (it && typeof it === 'object') return [it.product_id, it.variant_id, it.quantity || 1];
      return [null, null, 1];
    });
  }

  function getBookmarkItems() {
    var account = getAccountItems();
    if (account) return account;
    var raw = null;
    if (typeof window.getCookieSW === 'function') {
      try { raw = window.getCookieSW('bookmarkeditems'); } catch (e) { raw = null; }
    }
    if (raw == null) {
      var c = document.cookie
        .split(';')
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.indexOf('bookmarkeditems=') === 0; })[0];
      if (c) {
        raw = c.substring('bookmarkeditems='.length);
        try { raw = decodeURIComponent(raw); } catch (e) { /* 生JSON */ }
      }
    }
    if (!raw) return [];
    try {
      var json = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return (json && json.items) || [];
    } catch (e) {
      return [];
    }
  }

  function inWishlist(items, pid, vid) {
    if (!pid) return false;
    return items.some(function (it) {
      return String(it[0]) === String(pid) && String(it[1]) === String(vid);
    });
  }

  function setState(btn, on) {
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'お気に入りから削除' : 'お気に入りに追加');
  }

  /* cookie 反映待ちのあいだ表示する楽観件数（null = cookie の実数を出す） */
  var favOptimistic = null;
  var favSettleTimer = null;

  /* ヘッダーお気に入りアイコンの件数バッジ更新（PC ヘッダー行 + SP ドロワー内トップバーの両方）。
     件数の正は cookie(bookmarkeditems)＝テーマ内で完結し、アプリのウィジェット注入設定に依存しない。
     0 件は空文字にして Dawn の .cart-count-bubble:empty{visibility:hidden} に任せる（cart と同挙動）。
     件数>0 の時だけ親アンカーへ .pbk-has-fav-count を付け、アプリ注入 .topbadge を CSS 側で抑止する
     （バッジ二重表示の防止）。cookie に載らないログイン会員ではクラスが付かないので、
     従来どおりアプリの .topbadge がフォールバックとして残る。 */
  function updateFavCount() {
    var bubbles = document.querySelectorAll('.pbk-fav-count-bubble');
    var anchors = document.querySelectorAll(
      '.pbk-header__icons .header__icon--fav, .pbk-header__icons a[href*="wishlist"]'
    );
    if (!bubbles.length && !anchors.length) return;
    var n = favOptimistic != null ? favOptimistic : getBookmarkItems().length;
    var label = n > 0 ? (n < 100 ? String(n) : '99+') : '';
    bubbles.forEach(function (bubble) { bubble.textContent = label; });
    anchors.forEach(function (a) { a.classList.toggle('pbk-has-fav-count', n > 0); });
  }

  /* 登録済ハートを塗る(guest cookie 基準)。データ未取得時は既定(未塗り)のまま */
  function sync(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = getBookmarkItems();
    scope.querySelectorAll(SELECTOR).forEach(function (btn) {
      var pid = btn.getAttribute('data-product-id');
      var vid = btn.getAttribute('data-product-variant');
      setState(btn, inWishlist(items, pid, vid));
    });
    updateFavCount();
  }
  window.pbkSyncWishlistFav = sync;

  /* SP はスクロールでヘッダーが隠れるため、一覧でお気に入りを押しても件数バッジが
     見えず登録できたか分からない。sticky-header(sections/header.liquid)が
     'pbk:header-reveal' を拾い、隠れている時だけヘッダーを出し直す */
  function revealHeader() {
    document.dispatchEvent(new CustomEvent('pbk:header-reveal'));
  }

  /* 押した直後にバッジを増減させ、cookie が追いついたら実数へ戻す。
     アプリの Add/Remove は cookie を同期で書く（dev 実機計測: click と同一 tick で反映）ので
     通常は api() 直後の updateFavCount() だけで正しい数が出る。ただし
     ・アプリが将来 cookie を非同期で書く
     ・ログイン会員で cookie に載らない（0 のまま = 増えない）
     ケースがあるので、before と比べて変化を検出するまでは楽観値を表示し、
     1.5 秒で打ち切って実数（またはアプリ .topbadge）に委ねる。 */
  function settleFavCount(before, delta) {
    favOptimistic = Math.max(0, before + delta);
    updateFavCount();
    if (favSettleTimer) clearInterval(favSettleTimer);
    var tries = 0;
    favSettleTimer = setInterval(function () {
      tries++;
      if (getBookmarkItems().length !== before || tries >= 15) { // 100ms × 15 = 1.5秒
        clearInterval(favSettleTimer);
        favSettleTimer = null;
        favOptimistic = null;
        updateFavCount();
      }
    }, 100);
  }

  function toggle(btn) {
    var pid = btn.getAttribute('data-product-id');
    var vid = btn.getAttribute('data-product-variant');
    if (!pid || !vid) return;

    var willAdd = !btn.classList.contains('is-active');
    var api = willAdd ? window.AddToSmartWishlist : window.RemoveFromSmartWishlist;
    if (typeof api !== 'function') return; // アプリ未ロード時は無反応(既定に留める)

    var before = getBookmarkItems().length; // api 呼び出し前のスナップショット
    api(pid, vid);
    setState(btn, willAdd); // 楽観的トグル(API内部で ReloadSmartWishlist も走る)
    settleFavCount(before, willAdd ? 1 : -1); // 件数バッジを即時反映
    revealHeader();
  }

  /* 委譲クリック(document 直下・動的カードも捕捉)。
     .pbk-card__fav は <a> 内のため既定遷移とバブルを止める */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  /* span(role=button)のキーボード操作。native button は click が自動発火するので除外 */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var btn = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!btn || btn.tagName === 'BUTTON') return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  /* ------------------------------------------------------------
     お気に入りページ(/a/wishlist)のカードを通常一覧と同じ形にする。

     app(v7 sw_mywishlist.js)のカードは
       .product > .image > a > img  /  .text > h3.product_title, p(価格), p.buttons > 削除 + カート追加
     で、削除ボタンはテキストの下に横並びで出る。通常一覧はカード右上のハート＝
     登録済み解除なので、app の削除ボタン自身を .image 直下へ移設し中身をハート SVG に置換する。
     - ボタン要素を作り直さない → data-productid/variantid/product_title/product_image と
       app の委譲クリック（削除確認モーダル #remove_modal）がそのまま生きる
     - btn/btn-warning/removebutton の bootstrap クラスは外す（ピル装飾を持ち込まない）。
       app JS がカード削除に使うフックは .singleremovebutton のみ（.removebutton は
       クリア全削除 .clearall 側でしか参照されない）ため外して安全
     - 一度処理したボタンは data-pbk-wl-fav で除外（MutationObserver の自己再入を止める）
     ------------------------------------------------------------ */

  /* 通常一覧と同一の Figma ハート（pbk-icon-fav-line / pbk-jewelry-facets.js の favSvg と同じパス。
     viewBox はグリフ密着 bbox = Figma icon_fav 15.695×14。塗りは CSS の is-active で入れる） */
  var WL_FAV_SVG =
    '<svg class="pbk-wl-card__fav-icon" viewBox="0.5002 1.8984 15.6951 14" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M8.3494 3.78573C6.04138 1.25748 3.35456 1.49533 1.6808 3.16908C0.00704669 4.84284 0.209659 7.37109 1.6808 9.22984C3.25766 11.2295 8.3494 15.8984 8.3494 15.8984C8.3494 15.8984 13.4411 11.2207 15.018 9.22984C16.4803 7.37109 16.6917 4.84284 15.018 3.16908C13.3442 1.49533 10.6574 1.25748 8.3494 3.78573Z" stroke="currentColor" stroke-miterlimit="10" fill="none"/></svg>';

  /* グリッド先頭セルを食う「見えない項目」の掃除（CL #289: 複数件登録すると 1 枚目が
     1 列ずれる）。CSS Grid は空白のみでないテキストノードも匿名グリッド項目にするため、
     app が #bookmarks 直下に落とす &nbsp; / ゼロ幅文字だけのテキストが 1 セルを占有し、
     先頭カードが次のセルへ押し出される。要素側のはみ出しは pbk-wishlist.css の
     `> *:not([id^="product_"])` → grid-column:1/-1 で吸収するが、テキストノードは
     セレクタで掴めないため JS で除去する（可視文字を含むノードは触らない）。 */
  var INVISIBLE_ONLY = /^[\s\u00a0\u200b-\u200d\u2060\ufeff]+$/;
  function stripPhantomTextNodes(list) {
    [list].concat([].slice.call(list.querySelectorAll('.container-fluid, .container-fluid > .row')))
      .forEach(function (parent) {
        [].slice.call(parent.childNodes).forEach(function (n) {
          if (n.nodeType === 3 && n.nodeValue && INVISIBLE_ONLY.test(n.nodeValue) && /[\u00a0\u200b-\u200d\u2060\ufeff]/.test(n.nodeValue)) {
            parent.removeChild(n);
          }
        });
      });
  }

  function decorateWishlistCards(list) {
    stripPhantomTextNodes(list);
    list.querySelectorAll('.product').forEach(function (card) {
      var btn = card.querySelector('.singleremovebutton');
      var image = card.querySelector('.image');
      if (btn && image && btn.getAttribute('data-pbk-wl-fav') !== '1') {
        btn.setAttribute('data-pbk-wl-fav', '1');
        btn.className = 'singleremovebutton pbk-wl-card__fav is-active';
        btn.setAttribute('aria-label', 'お気に入りから削除');
        btn.setAttribute('aria-pressed', 'true');
        btn.innerHTML = WL_FAV_SVG;
        image.appendChild(btn); // 商品リンク <a> の内側には入れない（入れ子アンカーを作らない）
      }
      // スペック(カラット/サイズ)・価格は app データに無いため metafield を fetch して補う
      fetchCardMeta(card);
    });
  }

  /* ------------------------------------------------------------
     通常一覧と同じスペック(カラット/サイズ)・価格の補完。
     app カードは title/価格しか持たず metafield を含まないため、handle から
     alternate template `/products/<handle>?view=wl-card` を fetch して
     .pbk-wl-row（スペック左 / 価格右）を .text に挿入する。1 カード 1 回（data-pbk-meta）。
     ------------------------------------------------------------ */
  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return '¥' + Math.round(n / 100).toLocaleString('ja-JP'); // Shopify price は最小単位×100(JPYは×100表現)
  }

  function cardHandle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function specText(meta) {
    var c = meta.carat != null ? String(meta.carat).trim() : '';
    var s = meta.size_mm != null ? String(meta.size_mm).trim() : '';
    if (c && s) return c + 'ct / ' + s + 'mm';
    if (c) return c + 'ct';
    return '';
  }

  function renderCardMeta(card, meta) {
    var text = card.querySelector('.text');
    if (!text) return;
    var row = text.querySelector('.pbk-wl-row');
    if (!row) { row = document.createElement('div'); row.className = 'pbk-wl-row'; text.appendChild(row); }
    var priceHtml;
    if (meta.compare_at_price && Number(meta.compare_at_price) > Number(meta.price)) {
      priceHtml = '<span class="pbk-wl-price-was">' + money(meta.compare_at_price) + '</span>' +
                  '<span class="pbk-wl-price-now">' + money(meta.price) + '</span>';
    } else {
      priceHtml = money(meta.price);
    }
    var spec = document.createElement('span'); spec.className = 'pbk-wl-spec'; spec.textContent = specText(meta);
    var price = document.createElement('span'); price.className = 'pbk-wl-price'; price.innerHTML = priceHtml;
    row.textContent = '';
    row.appendChild(spec);
    row.appendChild(price);
    renderCardBadge(card, meta);
  }

  /* 左上バッジ = 通常一覧カード（pbk-loose-facets.js cardHtml）と同じ規則。
     在庫切れは SALE と同じ位置なので在庫切れを優先（同時には出さない）。
     app カードは在庫/セール状態を持たないため ?view=wl-card の available /
     compare_at_price から組む。挿入先は画像枠（PC はカード枠と同一ボックス）。 */
  function renderCardBadge(card, meta) {
    var image = card.querySelector('.image');
    if (!image) return;
    var old = image.querySelector('.pbk-wl-card__badge');
    if (old) old.parentNode.removeChild(old);
    var soldOut = meta.available === false;
    var onSale = !soldOut && meta.compare_at_price && Number(meta.compare_at_price) > Number(meta.price);
    if (!soldOut && !onSale) return;
    var badge = document.createElement('span');
    badge.className = 'pbk-wl-card__badge' + (soldOut ? ' pbk-wl-card__badge--soldout' : '');
    badge.innerHTML = soldOut ? 'SOLD&nbsp;&nbsp;OUT' : 'SALE';
    image.insertBefore(badge, image.firstChild);
  }

  function fetchCardMeta(card) {
    if (card.getAttribute('data-pbk-meta')) return; // pending or done は再取得しない
    var handle = cardHandle(card);
    if (!handle) return;
    card.setAttribute('data-pbk-meta', 'pending');
    fetch('/products/' + encodeURIComponent(handle) + '?view=wl-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (meta) {
        if (!meta) { card.removeAttribute('data-pbk-meta'); return; }
        card.setAttribute('data-pbk-meta', 'done');
        renderCardMeta(card, meta);
      })
      .catch(function () { card.removeAttribute('data-pbk-meta'); }); // 失敗時は次回 decorate で再試行
  }

  /* ------------------------------------------------------------
     フォールバック描画: app の getproductdetails.php(JSONP) が
     200+空bodyを返し続ける障害(2026-07 実測・Webmarked未修正)への保険。
     保存系(savewishlist/clearwishlist=cloud)と共有ビューのサーバー描画は
     生きているため、自分の wishlist_id の共有ビュー
       /a/wishlist/<store_id(__st.a)><wishlist_id(cookie)>
     を同一オリジン fetch し、サーバー描画済みカードを #bookmarks へ移植する。
     - 共有ビューのカードは削除ボタンを持たない → cookie と同じ pid/vid を持つ
       .singleremovebutton をテーマ側で生成（app の委譲クリック=削除確認モーダル
       #remove_modal と #modal_remove_button の $("#product_<pid>_<vid>").remove()
       がそのまま機能するよう、col ラッパー(id=product_…)ごと guest 構造で移植）
     - app が後から正常描画した場合は $("#bookmarks").html() で上書きされ消える
       （本フォールバックは app 描画 4 秒無反応時のみ発火）
     ------------------------------------------------------------ */

  function wishlistIdCookie() {
    var raw = null;
    if (typeof window.getCookieSW === 'function') {
      try { raw = window.getCookieSW('wishlist_id'); } catch (e) { raw = null; }
    }
    if (raw == null) {
      raw = (document.cookie.match(/(?:^|;\s*)wishlist_id=([^;]+)/) || [])[1] || null;
    }
    return raw && raw !== '0' ? raw : null;
  }

  function buildRemoveButton(card) {
    var pid = card.getAttribute('data-productid');
    var vid = card.getAttribute('data-variantid');
    if (!pid || !vid) return null;
    var a = document.createElement('a');
    a.className = 'btn btn-warning removebutton singleremovebutton';
    a.setAttribute('role', 'button');
    a.setAttribute('tabindex', '0');
    a.setAttribute('href', '#');
    a.setAttribute('aria-label', 'Remove from Wishlist');
    a.setAttribute('data-productid', pid);
    a.setAttribute('data-variantid', vid);
    var title = card.querySelector('.product_title');
    a.setAttribute('data-product_title', title ? title.textContent.trim() : '');
    var img = card.querySelector('.image img');
    a.setAttribute('data-product_image', img ? img.getAttribute('src') || '' : '');
    return a;
  }

  function bootWishlistFallback(list) {
    // 自分の一覧ページのみ（共有ビューには不要）
    if (window.location.pathname.replace(/\/+$/, '') !== '/a/wishlist') return;
    var tries = 0;

    var rendered = function () {
      return list.querySelector('.product') || list.querySelector('.empty-wishlist');
    };
    /* app と同文言の空メッセージ（見た目は既存 .empty-wishlist の上書きが当たる）。
       app は破損分岐で空メッセージすら描画しないことがあるためテーマ側で保険 */
    var showEmpty = function () {
      if (rendered()) return;
      var div = document.createElement('div');
      div.className = 'alert alert-info empty-wishlist';
      div.textContent = 'お気に入りに追加している商品はありません';
      list.innerHTML = '';
      list.appendChild(div);
    };

    var attempt = function () {
      tries++;
      if (rendered()) return; // app が描画済み(カード or 空メッセージ)なら何もしない
      var wid = wishlistIdCookie();
      // 共有ビュー URL の store_id 部分は smartwishlist の store_id。
      // app が current_shop_id / store_id グローバルに入れる（= __st.a と同値・実測 81513513173）。
      // どれか取れたものを使う（堅牢化）
      var sid = window.current_shop_id || (window.__st && window.__st.a) || window.store_id;
      if (!wid || !sid) {
        // wishlist_id が無い = サーバー側に復元対象が無い。
        // 初回はまだ cookie が書かれていない可能性があるので 1 回だけ待ち直す
        if (tries < 2) setTimeout(attempt, 4000);
        else showEmpty();
        return;
      }
      fetch('/a/wishlist/' + sid + wid, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          // 再確認: fetch 中に app が描画していたら譲る
          if (rendered()) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('#bookmarks .product');
          if (!cards.length) { showEmpty(); return; } // サーバー側も空 = 空状態を明示
          var frag = document.createDocumentFragment();
          cards.forEach(function (srcCard) {
            var card = document.importNode(srcCard, true);
            if (!card.querySelector('.singleremovebutton')) {
              var btn = buildRemoveButton(card);
              if (btn) (card.querySelector('.text') || card).appendChild(btn);
            }
            // guest 描画と同じ col ラッパー(id=product_<pid>_<vid>)で包む
            //（app の削除処理 $("#product_…").remove() と grid CSS の前提）
            var col = document.createElement('div');
            col.className = 'col-md-4 col-sm-4';
            col.id = 'product_' + card.getAttribute('data-productid') + '_' + card.getAttribute('data-variantid');
            col.appendChild(card);
            frag.appendChild(col);
          });
          list.innerHTML = '';
          list.appendChild(frag); // observer 経由で strip + decorate が走る
        })
        .catch(function () { /* 通信失敗時は誤った「0件」を出さず app 側(あるいは preloader)に委ねる */ });
    };
    setTimeout(attempt, 4000); // app の正常描画を待ってから
  }

  /* ------------------------------------------------------------
     お気に入りページ(/a/wishlist)のカード整形。
     app 自前の価格 <p>・カート追加ボタンは pbk-wishlist.css で非表示にし、
     スペック/価格は money()（ja-JP 桁区切り）で .pbk-wl-row として描き直す。
     アプリの非同期描画に追随してハート化 + メタ補完(decorateWishlistCards)を都度掛ける。
     ------------------------------------------------------------ */
  function bootWishlistPage() {
    var list = document.getElementById('bookmarks'); // お気に入りページ以外には無い
    if (!list) return;

    decorateWishlistCards(list);
    // アプリがカードを非同期描画・再描画する(削除/共有/ページ送り)ため監視して都度ハート化。
    // 処理済みは data-pbk-wl-fav で除外されるため observer が自分の書換で無限ループにならない
    new MutationObserver(function () { decorateWishlistCards(list); })
      .observe(list, { childList: true, subtree: true });

    bootWishlistFallback(list);
  }

  /* アプリが状態変化時に呼ぶ ReloadSmartWishlist をラップして sync を相乗りさせる。
     アプリのスクリプトは DOMContentLoaded より後に読まれることがあり、その場合
     boot 時点では未定義でラップできない（実測: dev で未設置＝押しても件数が追従しない）。
     取れるまで下のポーリングで毎回試す。 */
  function wrapReload() {
    if (typeof window.ReloadSmartWishlist !== 'function') return false;
    if (window.ReloadSmartWishlist.__pbkWrapped) return true;
    var orig = window.ReloadSmartWishlist;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      sync();
      return r;
    };
    wrapped.__pbkWrapped = true;
    window.ReloadSmartWishlist = wrapped;
    return true;
  }

  /* 初期塗り: アプリの非同期データロードに追随して複数回 sync */
  function boot() {
    sync();
    bootWishlistPage();
    wrapReload();
    // 登録データが入るタイミング（guest = cookie 書込 / 会員 = saved_wishlist_items 受信）を
    // 短時間ポーリングで拾う。会員データはサーバ往復が入り cookie より遅いので 8 秒まで見る。
    var tries = 0;
    var synced = false;
    var timer = setInterval(function () {
      tries++;
      wrapReload();
      if (!synced && getBookmarkItems().length) { sync(); synced = true; }
      if (tries >= 16) clearInterval(timer); // 約8秒で打ち切り
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('pbk:cards-rendered', function () { sync(); });
})();
